











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, namespace } from 'vuex-class'
import { getEnvironments } from '@/environments'
import { PronosticoHistoricoElementAPI } from '@/domain/entities/Api'
const env = getEnvironments()

const PRONOSTICO_HISTORICO = 'pronosticoHistorico'

@Component({
  components: {
  }
})
export default class DescargaPronostico extends Vue {
  @Getter('pronosticoHistorico', { namespace: PRONOSTICO_HISTORICO })
  pronosticoHistorico!: PronosticoHistoricoElementAPI[]

  @Getter('linkDescarga', { namespace: PRONOSTICO_HISTORICO })
  linkDescarga!: string

  @Action('getPronosticoHistorico', { namespace: PRONOSTICO_HISTORICO })
  getPronosticoHistorico!: any

  @Action('getLinkDescarga', { namespace: PRONOSTICO_HISTORICO })
  getLinkDescarga!: any

  selectedEstacion: number | null = null
  selectedDate: string = ''

  created () {
    this.getPronosticoHistorico()
  }

  get isSelectedItems () {
    return this.selectedEstacion && this.selectedDate !== ''
  }

  async download () {
    await this.getLinkDescarga({ estacionId: this.selectedEstacion, fecha: this.selectedDate })
    location.assign(this.linkDescarga)
  }

  @Watch('dates')
  updatedDates () {
    this.selectedDate = ''
  }

  get formattedDates () {
    return this.dates ? this.dates.map((date: string) => ({
      id: date,
      date: `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)} ${date.substr(8, 2)}:${date.substr(10, 2)}`
    })) : []
  }

  get dates () {
    return this.selectedEstacion !== null
      ? (this.pronosticoHistorico.find(pron => pron.estacion_id === this.selectedEstacion) || { fecha_list: [] }).fecha_list
      : []
  }
}
